import { useStorage } from '@vueuse/core'
import { defineStore } from 'pinia'
import { computed } from 'vue'
import jwtDecode from 'jwt-decode'

export type DecodedToken = {
  user: {
    id: number
    email: string
  }
  exp: Date
  iat: Date
}

export const usePending2FAStore = defineStore('pending-2fa', () => {
  const token = useStorage<string | null>('kintsu-pending-2fa-token', null, localStorage)

  const payload = computed(() => {
    if (!token.value) {
      return null
    }
    try {
      return jwtDecode<DecodedToken>(token.value)
    } catch (error) {
      console.error(error)
      return null
    }
  })

  const user = computed(() => payload.value?.user)

  return {
    token,
    payload,
    user,
  }
})
